<script lang="ts">
    import { Button, Col, Image } from "sveltestrap";
    import { Contactfilter, href } from "../../../utils/Constant/Constant";
    import Card from "../../Core/Card.svelte";
    import ContactSidebar from "./ContactSidebar.svelte";
    let imgPath:string = "/assets/images/user"
    let open:boolean = false
</script>
<Col xl="3" class="xl-30 box-col-4">
    <div class="email-sidebar">
        <Button color="primary" class="email-sidebar-toggle" href={href} on:click={()=>open = !open}>{Contactfilter}</Button>
        <div class="email-left-aside {open ? "open" : ""}">
            <Card> 
                <div slot="contentbody">
                    <div class="email-app-sidebar left-bookmark"> 
                        <div class="media"> 
                            <div class="media-size-email">
                                <Image class="me-3 rounded-circle" src="{imgPath}/user.png" alt="" />
                            </div>
                            <div class="media-body">
                                <h6 class="f-w-600">{'MARK JENCO'}</h6>
                                <p>{'Markjecno@gmail.com'}</p>
                            </div>
                        </div>
                        <ContactSidebar />
                    </div>
                </div>
            </Card>
        </div>
    </div>
</Col>